import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import type { Mark } from "@tiptap/core"
import type { Mark as ProsemirrorMark, Schema } from "prosemirror-model"

import { ExtensionType } from "../../models"
import type { ExtendedRichTextNodeType } from "../../types"

export class ItalicExtension {
  extType: ExtensionType.Mark = ExtensionType.Mark
  richTextNodeTypes: ExtendedRichTextNodeType[] = [RichTextNodeType.em]
  constructor(
    readonly name: "em",
    readonly component: Mark,
    readonly converter: {
      fromPrismic(
        schema: Schema,
      ): (elmt: ItalicElement) => ProsemirrorMark | undefined
      toPrismic(elmt: ProsemirrorMark): undefined
    },
  ) {}
}

interface ItalicElement {
  type: "strong" | "em" | "list-item"
  start: number
  end: number
}
